var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPropertyChatEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "property-chat-event") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "property-chat-event",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(24.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2.5,
    x: 1.25,
    y: 2.73148148,
    width: 25.2671958,
    height: 21.2037037,
    rx: 4.06349206
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.55555556,
    y1: 8.22222222,
    x2: 26.4444444,
    y2: 8.22222222,
    id: "Line-2",
    stroke: "#FFFFFF",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.7777778,
    y1: 0.222222222,
    x2: 19.7777778,
    y2: 4.66666667,
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.22222222,
    y1: 0.222222222,
    x2: 8.22222222,
    y2: 4.66666667,
    id: "Line",
    stroke: "#FFFFFF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 7.6,
    cy: 17.4,
    r: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPropertyChatEvent);
export default __webpack_public_path__ + "static/media/property-chat-event.5396a64c19773b68fe42b4c5f6043047.svg";
export { ForwardRef as ReactComponent };